import { InternalLinkBlock, useGetFooterSettingsQuery } from "graphql/generated-types";
import Link from "next/link";
import React from "react";

import MenzieLogo from "@/icons/menzie-logo.svg";
import MSLogo from "@/icons/ms-logo.svg";

const Footer: React.FC = () => {
	const { data } = useGetFooterSettingsQuery();
	const footerSettings = data?.footerSettings;
	const socialMediaLinks = footerSettings?.socialMediaLinks as InternalLinkBlock[];
	const legalLinks = footerSettings?.legalLinks as InternalLinkBlock[];

	return (
		<footer className="bg-blue rounded-t-lg text-white">
			<div className="container flex flex-col gap-24 pb-14 pt-16 lg:flex-row lg:gap-4 lg:pb-20 lg:pt-28">
				<div className="flex flex-1 flex-col gap-8 lg:flex-row">
					<MenzieLogo className="max-w-[50%] lg:max-h-[70px]" />
					<MSLogo className="w-36 lg:max-h-[70px] lg:w-auto lg:max-w-[50%]" />
				</div>
				<div className="flex flex-1 flex-col gap-10">
					<p>{footerSettings?.acknowledgementOfCountry}</p>
					<div className="flex gap-36">
						<div className="flex flex-col gap-16">
							{footerSettings?.address && (
								<div
									className="whitespace-pre-wrap"
									dangerouslySetInnerHTML={{ __html: footerSettings?.address }}
								></div>
							)}
							{footerSettings?.contactPhone && <p>Phone: {footerSettings?.contactPhone}</p>}
						</div>
						<div className="hidden flex-col gap-11 lg:flex">
							<div className="flex flex-col gap-3">
								{socialMediaLinks?.map((link) => (
									<Link
										key={link.id}
										href={link.href}
										className="decoration-cyan whitespace-nowrap underline underline-offset-4"
									>
										{link.text}
									</Link>
								))}
							</div>
							<div className="flex flex-col gap-3">
								{legalLinks?.map((link) => (
									<Link
										key={link.id}
										href={link.href}
										className="decoration-cyan text-xxs whitespace-nowrap underline underline-offset-4"
									>
										{link.text}
									</Link>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
